import clsx from 'clsx';
import React from 'react';
import { AvatarPlaceholder } from './AvatarPlaceholder';
export const Avatar = (props) => {
    const { sources = [], className, placeholderLabel, alt, placeholderClassName, } = props;
    const clonedSources = [...sources];
    const defaultImage = clonedSources.pop();
    return (React.createElement("div", { className: clsx('rounded-full overflow-hidden flex-shrink-0 border border-app-gray-line', className) },
        defaultImage && (React.createElement("picture", null,
            clonedSources.map((source, index) => (React.createElement("source", { srcSet: typeof source.size !== 'undefined'
                    ? `${source.url} ${source.size}`
                    : source.url, type: source.type, key: index }))),
            React.createElement("img", { src: defaultImage.url, alt: alt, width: "40", height: "40", className: "w-full h-full" }))),
        !defaultImage && (React.createElement(AvatarPlaceholder, { label: placeholderLabel, className: clsx('w-full h-full', placeholderClassName) }))));
};
